import {
  ACCEPTED_ATTACHMENT_EXTENSIONS,
  ACCEPTED_ATTACHMENT_MIME_TYPES,
  MAX_ATTACHMENT_SIZE_BYTES,
} from '@/api/messages/constants';

type Result = {valid: true} | {valid: false; reason: string};

function fileExtension(fileName: string): string {
  return fileName.includes('.') ? fileName.split('.').pop()!.toLowerCase() : '';
}

export default function validateAttachment(file: File): Result {
  const extensionAllowed = (
    ACCEPTED_ATTACHMENT_EXTENSIONS as readonly string[]
  ).includes(fileExtension(file.name));
  const mimeAllowed =
    file.type === '' ||
    (ACCEPTED_ATTACHMENT_MIME_TYPES as readonly string[]).includes(file.type);
  if (!extensionAllowed || !mimeAllowed) {
    return {valid: false, reason: 'Unsupported file type.'};
  }
  if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
    return {valid: false, reason: 'Files must be 100MB or smaller.'};
  }
  return {valid: true};
}
